import React, { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { Mode, Params } from './jobPostAction.type';
import AddJobPost from '../AddJobPost';

function JobPostAction() {
  const { mode, id, type } = useParams<Params>();

  const actionMapping: Record<Mode, ReactNode> = {
    edit: (
      <AddJobPost
        mode="edit"
        id={id}
        type={type === 'jobs' ? 'post' : 'internship'}
      />
    )
  };

  return mode && type ? actionMapping[mode] : null;
}

export default JobPostAction;
